import React, { useCallback } from "react";
import { Button, Icon, Text, useTheme } from "@bookingcom/bui-react";
import { SearchRemoveIcon } from "@bookingcom/bui-assets-react/streamline";
import { Trans } from "@bookingcom/lingojs-react";
import useCreateUrl from "../../../hooks/useCreateUrl.js";
import useGlobalContext from "../../../hooks/useGlobalContext.js";
import { FLIGHTS_INDEX_BASE_URL } from "../../../constants.js";
const NotFoundInner = () => {
    const theme = useTheme();
    const { createUrl } = useCreateUrl();
    const { lang } = useGlobalContext();
    const handleRedirect = useCallback(() => {
        window.location.href = createUrl(`${FLIGHTS_INDEX_BASE_URL}.${lang}.html`);
    }, [createUrl, lang]);
    return (React.createElement("div", { style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 72,
            marginBottom: theme.units.spacing_16x
        } },
        React.createElement(Icon, { svg: SearchRemoveIcon, size: "large" }),
        React.createElement(Text, { tagName: "h2", variant: "headline_2", color: "neutral", attributes: {
                style: { marginBottom: 0 }
            } },
            React.createElement(Trans, { tag: "flights_not_found_no_page_title" })),
        React.createElement(Text, { variant: "body_1", color: "neutral_alt", attributes: {
                style: { marginBottom: theme.units.spacing_6x }
            } },
            React.createElement(Trans, { tag: "flights_not_found_no_page_subtitle" })),
        React.createElement(Button, { size: "large", onClick: handleRedirect },
            React.createElement(Trans, { tag: "flights_not_found_no_page_cta" }))));
};
export default NotFoundInner;
